import Button from '@components/DesignLibrary/Button';
import Image from 'next/image';
import Spacer from '@components/Spacer';
import s from './CreditReportModal.module.scss';

const CONFIRM = {
  description: '',
  title: "You're all set. Thank you.",
};

type Props = {
  nextStep: () => void;
};

const Confirm: React.FC<Props> = ({ nextStep }) => (
  <div className={s.confirm}>
    <Image src="/images/credit-report/check.png" alt="" width={168} height={168} />

    <h2 className="heading-sm">You&apos;re all set. Thank you.</h2>
    {CONFIRM.description && (
      <>
        <Spacer size={8} />
        <p className="caption">{CONFIRM.description}</p>
      </>
    )}
    <Spacer size={24} />

    <Button variant="primary" size="md" fullWidth onClick={nextStep} className={s.noodleColor}>
      Done
    </Button>
  </div>
);

export default Confirm;
